//import { authenticationService } from "@/Services/authentication_service";
import {
    AUTH_REDIRECT_URL,
    HOSTNAME,
    USER_IDENTITY_CONFIG,
} from '@/constants/constantsAckoDrive';

export const getLoginUrl = (redirectUrl: string) => {
    if (!redirectUrl) return '';
    let utmParamsString: string = '';

    const state = {
        redirectUrl: `${HOSTNAME}${process.env.NEXT_PUBLIC_ENV_PREFIX}${redirectUrl}`,
    };
    const stateString = JSON.stringify(state);

    // let eventParams = {};
    // if (typeof window !== "undefined") {
    //   const isLoggedOutClicked = localStorage.getItem("LogoutClicked");
    //   if (!authenticationService.isLoggedIn() && isLoggedOutClicked !== "true") {
    //     setReferrer(document.referrer);
    //   }
    //   eventParams = {
    //     url: window.location.pathname,
    //     platform: getPlatform(),
    //     journey: getJourney(),
    //     city_name: cityName,
    //     page: window.location.href,
    //     path: window.location.pathname,
    //     referrer: getReferrer() || "",
    //     lead_source: sessionStorage.getItem("lead_source") || "",
    //   };
    // }

    //const eventParamsString = JSON.stringify(eventParams);

    let loginUrl = `${USER_IDENTITY_CONFIG.ACKO_HOSTNAME}/v1/signin?client_id=${
        USER_IDENTITY_CONFIG.CLIENT_ID
    }&redirect_uri=${AUTH_REDIRECT_URL}&state=${encodeURIComponent(
        stateString
    )}&response_type=${USER_IDENTITY_CONFIG.RESPONSE_TYPE}&identity_type=${
        USER_IDENTITY_CONFIG.IDENTITY_TYPE
    }&scope=${USER_IDENTITY_CONFIG.SCOPE}&realm=${USER_IDENTITY_CONFIG.REALM}`;

    if (!!utmParamsString) {
        loginUrl += `&${utmParamsString}`;
    }
    return loginUrl;
};
